import * as React from "react";
import {useState} from "react";
import {SliderComponent} from "../common/Slider.component";

export const METHODOLOGY_DISCLOSURES = "Methodology and Disclosures";
export const PortfolioMethodology: React.FunctionComponent = () => {
    const [displaySlider, setDisplaySlider] = useState(false);

    const getText = () => {
        return <div className={"portfolio-methodology__slider-text"}>
            <div>
                Aon plc is a large diversified professional services company, and such services are provided through
                indirect subsidiaries and affiliated entities. Aon plc affiliates provide investment advisory services
                in jurisdictions worldwide. The Aon plc affiliated entities that have issued this material are listed
                below, along with important limitations on their authorized activities.
            </div>
            <div>
                <b>Canada:</b> Advisory investment consulting services are provided through Aon Solutions Canada Inc.
                and OCIO services are provided through Aon Investments Canada Inc., which is registered as a portfolio
                manager.
            </div>
            <div>
                <b>United Kingdom:</b> Aon Investments Limited is authorized and regulated by the Financial Conduct
                Authority. Registered in England & Wales No. 5913159.
            </div>
            <div>
                <b>United States:</b> Investment advice and consulting services provide by Aon Investments USA Inc. Aon
                Investments USA Inc. is registered with the U.S. Securities and Exchange Commission as an investment
                adviser pursuant to the Investment Advisers Act of 1940. Registration of an investment adviser does not
                imply any certain level of skill, training, or ability with respect to the provision of investment
                advisory services.
            </div>
            <div>
                Aon Solutions Canada Inc., Aon Investments Canada Inc., Aon Investments Limited and Aon Investments USA
                Inc. are indirectly owned by Aon plc, a publicly traded company (AON:NYSE). References to Aon shall be
                construed to include such indirect subsidiaries as the context requires.
            </div>
            <div>
                This information is provided as a management aid for the client’s internal use only. Information
                contained in this portal includes confidential and/or proprietary information of Aon and the client.
                The content of this portal is particular to the client and should not be relied upon by any other
                entity. This information is provided in connection with Aon’s investment advisory services and should
                not be viewed as an advertisement of Aon, or any of the strategies or products discussed or referenced.
                Aon believes that the information obtained from third-party sources contained herein is reliable but
                has not undertaken to verify such information. Aon gives no representations or warranties as to the
                accuracy of such information and accepts no responsibility or liability (including for indirect,
                consequential or incidental damages) for any error, omission or inaccuracy in such information and for
                results obtained from its use.
            </div>
            <div>
                Economic and market forecasts presented herein reflect our judgment as of the date of this presentation
                and are subject to change without notice. These forecasts are subject to high levels of uncertainty
                that may affect actual performance. Accordingly, these forecasts should be viewed as merely
                representative of a broad range of possible outcomes. These forecasts are estimated, based on
                assumptions, and are subject to significant revision and may change materially as economic and market
                conditions change. Given the inherent volatility of the securities markets, it should not be assumed
                that your investments will experience returns comparable to those shown in the analysis contained in
                this portal. For example, market and economic conditions may change in the future producing materially
                different results than those shown included in the analysis contained in this portal.
            </div>
            <div>
                Calculations may be derived from our proprietary models in use at that time. Models may be based on
                historical analysis of data and other methodologies, and we may have incorporated their subjective
                judgement to complement such data as is available. It should be noted that models may change over time,
                and they should not be relied upon to capture future uncertainty or events.
            </div>
            <div>
                <b>Hypothetical Performance and Characteristics:</b> This portal includes forward-looking (expected)
                return and risk projections which are hypothetical in nature and do not reflect the performance or
                characteristics of any actual investment portfolio or results that were achieved by a client portfolio
                under management or advisement. Such projected returns and risk characteristics reflect an estimate and
                are being presented as results that could be achieved by a real-world investment portfolio and are
                based on historical data and assumptions established through mathematical modeling. Throughout the
                analysis, hypothetical performance and characteristics utilizes our 10-year Capital Market Assumptions
                (“CMAs”) which provide long-term forecasts about the expected performance of different asset classes
                (including their returns, volatility, and correlations) and are designed to reflect the typical cost
                of implementing an investment program. Hypothetical performance and characteristics represent
                “simulated” results calculated by the retroactive application of investment modeling methodology
                developed with the benefit of hindsight and without actual money at risk. When determining
                forward-looking (expected) return and risk projections for a given portfolio’s asset allocation, each
                underlying asset class is mapped to an appropriate CMA (based on the representative benchmark indexes
                or other proxies). The calculation methodology assumes a static allocation to underlying asset class
                allocations and the historical data of Private Equity is presented on a 2-quarter lag. The hypothetical
                illustrations presented are based on Aon’s analysis and assumptions about the current market
                environment and market opportunities. Hypothetical performance has inherent limitations and may not
                accurately reflect the impact that any material market or economic factors might have on client assets
                and cannot account for the impact of financial risk in actual trading. In considering the analysis
                presented herein, investors should bear in mind that such hypothetical performance is not necessarily
                indicative of future results, and there can be no assurance that Aon will achieve comparable results or
                that such expected returns will be realized. Investors should not rely on hypothetical performance
                information as the sole basis for investment decisions.
            </div>
        </div>;
    };

    return <div className={"portfolio-methodology__container"}>
        <div className={"portfolio-methodology__link"} onClick={() => setDisplaySlider(true)} data-testid="portfolio-methodology__link">
            {METHODOLOGY_DISCLOSURES}
        </div>
        <SliderComponent
            hideSlider={() => setDisplaySlider(false)}
            header={METHODOLOGY_DISCLOSURES}
            content={getText()}
            display={displaySlider}/>
    </div>;
};

